import React from "react";

class Game {
    constructor(inits, user, pkg, config, react) {
        this.inits = inits;
        this.user = user;
        this.pkg = pkg;
        this.config = config;
        this.react = react;
    }

    useItem = idPos => {
        try {
            if (!idPos) return;

            const items = this.user.items;
            const item = items && items[idPos];

            // Slot vacío: no hay nada para usar.
            if (!item || !item.idItem) return;

            const objItem = this.inits.objs && this.inits.objs[item.idItem];

            if (objItem && objItem.proyectil && item.equipped) {
                this.react.setState({ crosshair: true });
                this.config.itemSelected = item.idItem;
            } else {
                if (
                    +Date.now() - this.config.timeItemStart >
                    this.config.intervalItem
                ) {
                    this.config.timeItemStart = +Date.now();

                    this.pkg.setPackageID(this.pkg.serverPacketID.useItem);
                    this.pkg.writeInt(idPos);
                    this.config.ws.send(this.pkg.dataSend());
                }
            }
        } catch (err) {
            console.log("useItem error:", err && err.message);
        }
    };

    equiparItem = (idPos, id) => {
        this.pkg.setPackageID(this.pkg.serverPacketID.equiparItem);
        this.pkg.writeInt(idPos);
        this.config.ws.send(this.pkg.dataSend());
    };

    // Envía el orden completo de hechizos al server (array de idSpell).
    // El server lo guarda en vars.personajes[ws.id].spellOrder y persiste
    // en el próximo save. Llamar después de cada reorder de la lista.
    updateSpellOrder = (idSpellArray) => {
        const arr = Array.isArray(idSpellArray) ? idSpellArray : [];
        this.pkg.setPackageID(this.pkg.serverPacketID.updateSpellOrder);
        this.pkg.writeByte(Math.min(arr.length, 255));
        for (let i = 0; i < arr.length && i < 255; i++) {
            this.pkg.writeShort(arr[i]);
        }
        this.config.ws.send(this.pkg.dataSend());
    };

    // Envía la lista de hechizos favoritos al server (array de idSpell,
    // hasta 6 elementos). Misma lógica que updateSpellOrder pero el server
    // los persiste en favoriteSpells.
    updateFavoriteSpells = (idSpellArray) => {
        const arr = Array.isArray(idSpellArray) ? idSpellArray : [];
        this.pkg.setPackageID(this.pkg.serverPacketID.updateFavoriteSpells);
        this.pkg.writeByte(Math.min(arr.length, 255));
        for (let i = 0; i < arr.length && i < 255; i++) {
            this.pkg.writeShort(arr[i]);
        }
        this.config.ws.send(this.pkg.dataSend());
    };

    connectCharacter = () => {
        // Defensa contra el bug "Still in CONNECTING state": si por algún
        // motivo el ws no está OPEN cuando llegamos acá (race entre
        // reconnect logic y onopen viejo — ver connection.js), bail.
        // La connection.js ya tiene su stale-check, esto es defensa en
        // segunda capa por si el ws se cierra entre el onopen y este send.
        if (
            !this.config.ws ||
            this.config.ws.readyState !== WebSocket.OPEN
        ) {
            return;
        }

        // idAccount + email viven en localStorage (account-wide, compartido
        // entre tabs del mismo browser). idCharacter/idChar/typeGame viven
        // en sessionStorage (per-tab) para que cada tab pueda tener su
        // propio personaje conectado sin pisar el de los otros tabs.
        this.pkg.setPackageID(this.pkg.serverPacketID.connectCharacter);
        this.pkg.writeString(localStorage.getItem("idAccount"));
        this.pkg.writeString(sessionStorage.getItem("idCharacter") || "");
        this.pkg.writeString(localStorage.getItem("email"));
        this.pkg.writeByte(parseInt(sessionStorage.getItem("typeGame")));
        this.pkg.writeByte(parseInt(sessionStorage.getItem("idChar")));

        this.config.ws.send(this.pkg.dataSend());
    };

    // Ticket #283: para chat, el badge solo se incrementa cuando llega
    // un mensaje "de atención":
    //   - whisper directo (lila #DA6FD1 / #FF80FF)
    //   - GM activo hablando en público (verde #419900)
    //   - broadcast del servidor [Servidor] (ámbar #E69500 típicamente)
    // El chat público normal de civiles (blanco) NO suma badge.
    _isChatAlert = (msg, color) => {
        const c = String(color || "").toLowerCase();
        if (c === "#da6fd1" || c === "#ff80ff") return true; // whisper
        if (c === "#419900") return true; // GM chat público
        if (/^\[Servidor\]/i.test(String(msg || ""))) return true;
        return false;
    };

    // Ticket #283: clasifica el msg a una de 3 tabs basándose en
    // content + color. Importante: el "white" puro NO es un trigger
    // suficiente para chat — muchos mensajes del sistema usan white
    // (ej. "Te has escondido entre las sombras", "Has recuperado X mana").
    // El chat real se distingue por el prefix `[Name]  msg`.
    _categorizeMsg = (msg, color) => {
        const m = String(msg || "");
        const c = String(color || "").toLowerCase();

        // 1) Broadcast del servidor — chat (alert).
        if (/^\[Servidor\]/i.test(m)) return "chat";

        // 2) Colores de whisper — chat (alert).
        if (c === "#da6fd1" || c === "#ff80ff") return "chat";

        // 2.5) Feedback de comandos de chat / party que el server manda en
        // rojo #FF6464. Aunque el COLOR sea rojo (que de otra forma caería
        // en "combat"), el CONTENIDO es de tipo chat — debe ir a la tab
        // Chat (y General). Ticket #305.
        if (
            /^El usuario .+ no está conectado/i.test(m) ||
            /^Tenés que escribir un mensaje/i.test(m) ||
            /^Aún no recibiste ningún susurro/i.test(m) ||
            /^Quien te invitó ya no está conectado/i.test(m)
        ) {
            return "chat";
        }

        // 3) Combat — colores rojos directos (daño hecho/recibido).
        if (
            c === "red" ||
            c === "#ff0000" ||
            c === "#ff2020" ||
            c === "#ff6464" ||
            c === "#ff7878" ||
            c === "#ff7847" ||
            c === "#c64a3a"
        ) {
            return "combat";
        }

        // 4) Mensajes de combate / status / acciones denegadas en hot
        // path de combate. Cobertura amplia — todos los "no puedes
        // atacar / tirar hechizos / esconderte", recovery de mana/HP,
        // status effects (oculto, paralizado, invisible), bloqueos,
        // resucitar, meditación, inspect de chars/NPCs, etc.
        if (
            // Inspect (right-click sobre char/NPC). Info de combate útil
            // — el GM staff sale en #419900 (verde) y antes solo se veía
            // en General; ahora también en Combate.
            /^Ves a /i.test(m) ||
            // Status — recovery, max, no suficiente.
            /^¡?Tienes (la mana|la maná|el mana|el maná|la salud|la vida|el HP)/i.test(m) ||
            /^¡?Has recuperado/i.test(m) ||
            /^¡?No tienes suficiente (mana|maná)/i.test(m) ||
            // Status — hide / invisible / paralisis / status sticks.
            /^¡?(Ya )?estás (oculto|escondido|paralizado|inmovilizado|invisible|muerto)/i.test(m) ||
            /^¡?Te has (escondido|ocultado|vuelto invisible)/i.test(m) ||
            /^¡?Ya no estás (oculto|invisible|paralizado|inmovilizado)/i.test(m) ||
            /^¡?No (has |puedes? )logrado esconderte/i.test(m) ||
            // Combat — acciones denegadas.
            /^Los muertos no pueden/i.test(m) ||
            /^Los arqueros no pueden/i.test(m) ||
            /^No puedes (atacar|tirar hechizos?|usar (esta arma|este hechizo)|ocultarte|resucitar)/i.test(m) ||
            /^¡?No puedes atacarte/i.test(m) ||
            /^¡?No puedes atacar a (otro|un usuario)/i.test(m) ||
            /^Solo puedes resucitar/i.test(m) ||
            /^No puedes resucitarte/i.test(m) ||
            /^El usuario no está muerto/i.test(m) ||
            /^Este hechizo no funciona/i.test(m) ||
            /^Solo (las clases mágicas|Clérigos y Druidas)/i.test(m) ||
            /^Debes (desactivar el seguro|dejar de meditar)/i.test(m) ||
            /^No tienes flechas/i.test(m) ||
            /^Fuera de alcance/i.test(m) ||
            // Damage / hits — "Le has pegado", "Le has fallado", "Has
            // lanzado X sobre Y", "Le has causado", "Le has curado",
            // "Has bloqueado", "Le has fallado".
            /^¡?(Le|Les) has (pegado|fallado|causado|curado)/i.test(m) ||
            /^¡?Has (lanzado|bloqueado|fallado)/i.test(m) ||
            // NPC/pet feedback contra el user.
            /^.+ te ha (causado|pegado|paralizado|bloqueado|fallado|inmovilizado)/i.test(m) ||
            /^Tu mascota .+ ha muerto/i.test(m) ||
            // Meditación.
            /^Terminas de meditar/i.test(m) ||
            // Spell-cast feedback con color #E69500 ambar puede ser
            // ambient (palabras mágicas) — esos ya van por dialog, no
            // por console, así que no llegan acá.
            // Cliente-side: "Hechizo no encontrado", "No tiene mana".
            /^Hechizo no encontrado/i.test(m) ||
            /^No tiene suficiente mana/i.test(m) ||
            /^Aún no puedes realizar/i.test(m)
        ) {
            return "combat";
        }

        // 5) Chat público de personajes: msg con prefix [Name]  (excluye
        // Servidor que ya capturamos arriba). Cubre chat civil, GM chat
        // (verde #419900) y dialogs de NPCs/jugadores que llegan con
        // dialog packet (haveName=1 en messages.js).
        if (/^\[[^\]]+\]\s+/.test(m)) return "chat";

        // 6) Resto → system. Loot, level up, XP, oro, items, spells
        // aprendidos, pet spawn, party invites, comandos GM feedback,
        // bank/trade, hogar/telep, online count, GM toggle. Sin badge,
        // solo visible en tab General (legacy comportamiento).
        return "system";
    };

    // Ticket #293: parsea un string raw y devuelve un array de fragments
    // (strings + <a> nodes) con URLs convertidas a links clickeables.
    // Detecta:
    //   - http(s)://...           full URLs
    //   - www.example.com         no-protocol www links
    //   - discord.gg/...          discord invites comunes
    //   - aoweb.net               dominio del juego (con o sin path)
    //
    // El regex usa lookahead conservador para no comer puntuación final
    // (".", ",", ")", "!", "?") que normalmente cierran la oración:
    //   "visita https://aoweb.net." → link sin el punto final.
    //
    // Cada <a> abre en pestaña nueva con noopener noreferrer (XSS/leak
    // prevention). React escapa el text content y los hrefs son derivados
    // del match, no del DOM.
    // Ticket #335: pre-procesador del chat. Antes de linkificar, splittea
    // el texto por los sentinels del Private Use Area:
    //   .. → wrap como emojiGray (filter: grayscale → GRIS)
    //   .. → wrap como emojiWhite (brightness(0) invert(1) → BLANCO)
    // Emitidos por el server en `party.formatPartyEmojis`. Cero work
    // por mensaje sin sentinels (el regex no matchea → exec devuelve null).
    _renderChatMsg = (text) => {
        if (!text) return [text];
        const STYLE_RE = /([^]*)|([^]*)/g;
        const parts = [];
        let last = 0;
        let m;
        let counter = 0;
        while ((m = STYLE_RE.exec(text)) !== null) {
            if (m.index > last) {
                parts.push(...this._linkifyText(text.slice(last, m.index)));
            }
            counter++;
            // m[1] presente → gray (fuera de rango); m[2] → white (muerto).
            const isGray = m[1] !== undefined;
            parts.push(
                <span
                    key={"sty-" + (this._consoleMsgCounter || 0) + "-" + counter}
                    className={isGray ? "emojiGray" : "emojiWhite"}
                >
                    {isGray ? m[1] : m[2]}
                </span>
            );
            last = m.index + m[0].length;
        }
        if (last < text.length) {
            parts.push(...this._linkifyText(text.slice(last)));
        }
        return parts;
    };

    _linkifyText = (text) => {
        if (!text) return [text];
        const re = /(\b(?:https?:\/\/|www\.)[^\s<>"']+|\bdiscord\.gg\/[A-Za-z0-9]+|\baoweb\.net(?:\/[^\s<>"']*)?)/gi;
        const parts = [];
        let last = 0;
        let m;
        let counter = 0;
        while ((m = re.exec(text)) !== null) {
            // Trim trailing punctuation común que rara vez es parte del
            // URL real. Si el match termina con ".,!?;:)]}" lo cortamos
            // y dejamos el char restante en el text fragment siguiente.
            let url = m[0];
            let trailing = "";
            while (url.length > 0 && /[.,!?;:)\]}>]$/.test(url)) {
                trailing = url.slice(-1) + trailing;
                url = url.slice(0, -1);
            }
            if (!url) continue;

            if (m.index > last) {
                parts.push(text.slice(last, m.index));
            }

            // Normalizar href: si no arranca con http(s):// le ponemos
            // https://. Las relativas (sin protocolo) sino se interpretan
            // como path del mismo origin.
            let href = url;
            if (!/^https?:\/\//i.test(href)) {
                href = "https://" + href;
            }

            counter++;
            parts.push(
                <a
                    key={"lnk-" + (this._consoleMsgCounter || 0) + "-" + counter}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="chatLink"
                    onClick={e => e.stopPropagation()}
                    title={href}
                >
                    {url}
                </a>
            );

            if (trailing) parts.push(trailing);
            last = m.index + m[0].length;
        }
        if (last < text.length) {
            parts.push(text.slice(last));
        }
        return parts;
    };

    writeConsole = (msg, color, bold, italic, skipBadge) => {
        // Ticket #300: state.messagesConsole queda solo como ESPEJO de la
        // tab activa (General) para mantener back-compat con código viejo
        // que pueda referenciarlo. La verdad ahora vive en
        // state.messagesByTab — un dict {general, combat, chat, system} con
        // cap por bucket. Esto resuelve la pérdida de mensajes cuando un
        // burst de combat empuja afuera del cap legacy (40 total) a los
        // mensajes de chat que el user todavía no leyó.
        const { messagesByTab } = this.react.state;

        if (!color) {
            color = "white";
        }

        if (bold) {
            bold = "bold";
        } else {
            bold = "normal";
        }

        if (italic) {
            italic = "italic";
        } else {
            italic = "normal";
        }

        // Counter monotónico para el key de React. Antes era `+new Date()`
        // pero cuando el server manda 2+ msgs al toque (ej. "Le has pegado"
        // + "¡Has apuñalado!" del mismo userDmgNpc), ambos caían en el
        // mismo millisecond → mismo key → React deduplicaba en silencio y
        // se perdía el segundo msg. Counter elimina la colisión.
        this._consoleMsgCounter = (this._consoleMsgCounter || 0) + 1;

        // Si el msg matchea el formato de chat `[Nombre]  resto`, hacemos
        // el nombre clickeable → click izq abre el chat con /w prefilled
        // listo para susurrar a esa persona. Aplica a chat público,
        // whispers, y a cualquier dialog con console=1 que use ese formato
        // (incluyendo NPCs hablando — click va a fallar con "no conectado"
        // pero es feedback aceptable).
        const baseStyle = {
            color: color,
            fontWeight: bold,
            fontStyle: italic
        };

        const nameMatch = msg.match(/^\[([^\]]+)\]( +)(.*)$/);
        let content;
        if (nameMatch) {
            const name = nameMatch[1];
            const sep = nameMatch[2];
            const rest = nameMatch[3];
            // Decode htmlEntities back para mostrar texto natural (JSX
            // re-escapa para prevenir XSS automáticamente).
            const restDecoded = rest
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&quot;/g, '"')
                .replace(/&amp;/g, "&");

            const onNameClick = e => {
                e.preventDefault();
                e.stopPropagation();
                if (
                    this.react &&
                    typeof this.react.openWhisperTo === "function"
                ) {
                    this.react.openWhisperTo(name);
                }
            };

            // Ticket #301: chat de GM (color verde #419900) — solo `[Name]`
            // queda en verde, el resto del mensaje en blanco. Patrón clásico
            // de admin chat: identificás al GM por el nombre destacado, leés
            // el contenido en color normal. El check de "es chat de GM" usa
            // el hex color tal como lo manda el server (dialog en protocol.js).
            // Si en algún momento se quiere extender a otros tonos (mod #2 en
            // otro color, etc.), agregar acá.
            const isGmChat =
                typeof color === "string" &&
                color.toLowerCase() === "#419900";
            const restStyle = isGmChat
                ? { ...baseStyle, color: "white" }
                : null;

            content = (
                <span style={baseStyle} key={"msg-" + this._consoleMsgCounter}>
                    [
                    <a
                        href="#"
                        onClick={onNameClick}
                        style={{
                            color: "inherit",
                            cursor: "pointer",
                            textDecoration: "none"
                        }}
                        title={"Susurrar a " + name}
                    >
                        {name}
                    </a>
                    ]
                    {restStyle ? (
                        <span style={restStyle}>
                            {sep}
                            {this._renderChatMsg(restDecoded)}
                        </span>
                    ) : (
                        <React.Fragment>
                            {sep}
                            {this._renderChatMsg(restDecoded)}
                        </React.Fragment>
                    )}
                </span>
            );
        } else {
            // Ticket #293: replaced dangerouslySetInnerHTML with safe
            // text + linkify. El server no manda HTML al console (todos
            // los call-sites de handleProtocol.console son strings raw),
            // así que el innerHTML era innecesario y abría XSS si algún
            // día se filtraba input de player. Decodificamos entities
            // por si algún code path antiguo las metió.
            const decoded = String(msg || "")
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&quot;/g, '"')
                .replace(/&amp;/g, "&");
            content = (
                <span style={baseStyle} key={"msg-" + this._consoleMsgCounter}>
                    {this._renderChatMsg(decoded)}
                </span>
            );
        }

        // Ticket #300: buckets per-tab + inmutabilidad. Antes mutábamos
        // directo state.messagesConsole y caps a 40 total — un burst de
        // combat empujaba afuera mensajes de chat sin leer. Ahora cada tab
        // mantiene su propio array con cap MAX_MSGS_PER_TAB = 200. Burst
        // de combat no toca el bucket de chat. Inmutabilidad garantiza
        // re-render en cada msg (antes el shallow-compare de React podía
        // saltarlo cuando setStates se batcheaban).
        //
        // IMPORTANTE: usar functional setState para leer state actualizado
        // (`prev` siempre es el último valor committed). Sin esto, varios
        // writeConsole en el mismo tick leen el state stale y se pisan.
        const category = this._categorizeMsg(msg, color);
        const MAX_MSGS_PER_TAB = 200;
        const entry = { content, category };

        // Auto-scroll deferred — necesita conocer si el user está pegado
        // al fondo ANTES del re-render. Si está, scrolleamos al fondo
        // post-setState (en el callback). Si NO está, mantenemos su pos
        // de scroll y el badge "↓ N nuevos" en el state se incrementa.
        const consoleElem = this.react.refs && this.react.refs.console;
        let wasAtBottom = true;
        if (consoleElem) {
            const scrollHeight = consoleElem.scrollHeight;
            const height = consoleElem.clientHeight;
            const scrollTop = consoleElem.scrollTop;
            const distFromBottom = scrollHeight - height - scrollTop;
            // 28px de tolerancia ≈ ~2 líneas de chat. Si el user está
            // exactamente en el fondo o casi (típicamente entre msg y msg
            // el scroll cae 1-2px), sigue auto-scroll. Si subió más, NO.
            wasAtBottom = distFromBottom <= 28;
        }

        this.react.setState(prev => {
            // General = stream completo (todas las categorías).
            // Otras tabs = subset por categoría.
            const buckets = prev.messagesByTab || {
                general: [],
                combat: [],
                chat: [],
                system: []
            };
            const next = {
                general: buckets.general ? buckets.general.slice() : [],
                combat: buckets.combat ? buckets.combat.slice() : [],
                chat: buckets.chat ? buckets.chat.slice() : [],
                system: buckets.system ? buckets.system.slice() : []
            };
            next.general.push(entry);
            if (next.general.length > MAX_MSGS_PER_TAB) next.general.shift();
            if (next[category]) {
                next[category].push(entry);
                if (next[category].length > MAX_MSGS_PER_TAB) next[category].shift();
            }

            // Badge — solo si tab activa ≠ categoría del msg + cat es
            // combat o (chat + alert) + NO es el propio user (#303).
            const activeTab = prev.chatTab || "general";
            let unreadByTab = prev.unreadByTab;
            if (activeTab !== category && !skipBadge) {
                let shouldBadge = false;
                if (category === "combat") {
                    shouldBadge = true;
                } else if (
                    category === "chat" &&
                    this._isChatAlert(msg, color)
                ) {
                    shouldBadge = true;
                }
                if (shouldBadge) {
                    const baseUnread = unreadByTab || {
                        chat: { count: 0, color: null },
                        combat: { count: 0, color: null }
                    };
                    const prevRaw = baseUnread[category];
                    const prevBucket =
                        typeof prevRaw === "object" && prevRaw
                            ? prevRaw
                            : { count: prevRaw || 0, color: null };
                    unreadByTab = {
                        ...baseUnread,
                        [category]: {
                            count: (prevBucket.count || 0) + 1,
                            color: color || prevBucket.color || null
                        }
                    };
                }
            }

            // Counter "N mensajes nuevos abajo" — solo si el user
            // scrolleó hacia arriba y no estaba en el fondo. Cuando llega
            // al fondo, se resetea (handler de scroll en index.js).
            let scrollPending = prev.chatScrollPending || 0;
            const isVisibleInActive =
                activeTab === "general" || activeTab === category;
            if (!wasAtBottom && isVisibleInActive) {
                scrollPending = scrollPending + 1;
            }

            return {
                // Espejo de la tab activa para back-compat — quien lea
                // state.messagesConsole sigue funcionando, pero el filter
                // real ahora pasa por messagesByTab.
                messagesConsole: next[activeTab] || next.general,
                messagesByTab: next,
                unreadByTab: unreadByTab,
                chatScrollPending: scrollPending
            };
        }, () => {
            // Callback post-render: auto-scroll solo si el user estaba
            // en el fondo ANTES del nuevo mensaje. Sino respetamos su pos.
            const el = this.react.refs && this.react.refs.console;
            if (!el) return;
            if (wasAtBottom) {
                const scrollHeight = el.scrollHeight;
                const height = el.clientHeight;
                const maxScrollTop = scrollHeight - height;
                el.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
                // Reset del pending counter al volver al fondo.
                if (this.react.state.chatScrollPending > 0) {
                    this.react.setState({ chatScrollPending: 0 });
                }
            }
        });
    };
}

export default Game;
